import { render, staticRenderFns } from "./OtherMenuDropDown.vue?vue&type=template&id=5ca5b860&scoped=true&"
import script from "./OtherMenuDropDown.vue?vue&type=script&lang=js&"
export * from "./OtherMenuDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5b860",
  null
  
)

export default component.exports